module.exports = __webpack_public_path__ + "img/BEE-NL.f597125f.png";